/** @source https://stackoverflow.com/a/4912870 **/
Number.prototype.toFixedDown = function(digits) {
    var re = new RegExp("(\\d+\\.\\d{" + digits + "})(\\d)"),
        m = this.toString().match(re);
    return m ? parseFloat(m[1]) : this.valueOf();
};

$('select[name^="score_"]').on('change', function() {
    let score = 0
    let inputs = 0

    $('select[name^="score_"]').each(function() {
        const value = $(this).val()

        if (value === '' || value === "0" ) {
            return true // continue
        }

        score += parseInt(value)
        inputs++
    })

    score = score / inputs

    $('#total_score').val(score.toFixed(2))
})
